import React from 'react';
import {ButtonBase} from './ButtonBase';
import {IButtonBaseProps} from './IButtonBaseProps';

interface IButtonPrimaryProps extends IButtonBaseProps {
  isFirst?: boolean;
  isLast?: boolean;
}

export function ButtonPrimary({
  children,
  clickHandler,
  disabled = false,
  endIcon = null,
  startIcon = null,
  size = 'large',
  type = 'button',
  isFirst = false,
  isLast = false,
  className = '',
  mouseDownHandler,
}: IButtonPrimaryProps) {
  return (
    <ButtonBase
      variant="contained"
      color="primary"
      clickHandler={clickHandler}
      disabled={disabled}
      endIcon={endIcon}
      startIcon={startIcon}
      size={size}
      type={type}
      isFirst={isFirst}
      isLast={isLast}
      className={className}
      mouseDownHandler={mouseDownHandler}
    >
      {children}
    </ButtonBase>
  );
}
